<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
</script>

<div id="close-button-box">
    <a href={"#"} class="close1" on:click={() => dispatch("close")}> </a>
</div>

<style>
    .close1 {
        position: absolute;
        right: 24px;
        top: 12px;
        width: 16px;
        opacity: 0.3;
    }
    .close1:hover {
        opacity: 0.75;
    }
    .close1:before,
    .close1:after {
        position: absolute;
        left: 15px;
        content: " ";
        height: 25px;
        width: 2px;
        background-color: #333;
    }
    .close1:before {
        transform: rotate(45deg);
    }
    .close1:after {
        transform: rotate(-45deg);
    }
</style>
